const echarts = require("echarts");

export const chartone = (data) => {
  
  return {
    grid: {
      top: '50', 
      left: '10', 
      right: '10',
      bottom: '10',
      containLabel: true
    },
    tooltip: {
      trigger: "axis",
      // axisPointer: {
      //   type: "shadow",
      // },
    },
    legend: {
      show: true,
      // x: "center",
      top: "20",
      icon: 'rect',
      textStyle: {
        color: '#fff',
        fontSize: "8",
      },
      data: ["线上文娱", "线下活动"],
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisTick: {
        alignWithLabel: true
      },
      splitLine: {
        show: false
      },
      nameTextStyle: {
        color: '#fff',
      },
      axisLabel: {
        color: '#fff',
      },
      axisTick:{
        "show":false //隐藏x轴刻度
      },
      data: data.xdata,
    },
    yAxis: {
      type: 'value',
      axisTick: {
        alignWithLabel: true
      },
      splitLine: {
        show: false
      },
      nameTextStyle: {
        color: '#fff',
      },
      axisLabel: {
        color: '#fff',
      },
      axisTick:{
        "show":false //隐藏x轴刻度
      },
    },
    series: [
      {
        name: '线上文娱',
        data: data.ydata1,
        type: 'line',
        smooth: false,
        itemStyle:{
          normal: {
            color: '#A2FFFF',
            borderColor: '#A2FFFF',
          }
        },
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgb(101, 251, 248)'
            },
            {
              offset: 1,
              color: 'rgb(19, 33, 52)'
            }
          ])
        },
      },
      {
        name: '线下活动',
        data: data.ydata2,
        type: 'line',
        smooth: false,
        itemStyle:{
          normal: {
            lineStyle: {
              type: 'dotted',
            },
            color: '#F9F262',
            borderColor: '#F9F262',
          }
        },
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgb(249, 242, 98)'
            },
            {
              offset: 1,
              color: 'rgb(19, 33, 52)'
            }
          ])
        },
      }
    ]
  }
}
export const charttwo = (data) => {
  return {
    textStyle: {
      fontSize: 18,
    },
    title: {
      show: false,
      text: "",
      left: "left",
      textStyle: {
        color: "#fff",
        align: "center",
      },
    },
    grid: {
      left: "10",
      right: "10",
      bottom: "10",
      top: "50",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
        label: {
          show: true,
          backgroundColor: "#333",
        },
      },
    },
    legend: {
      show: true,
      x: "center",
      top: "10",
      textStyle: {
        color: "#fff",
        fontSize: "8",
      },
      itemHeight: 10,
      itemWidth: 10,
      data: ["健康教育", "手机知识", "防诈骗"],
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        axisLabel: {
          color: "#fff",
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)',
          },
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false,
        },
        data: data.xdata,
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "",
        axisLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)',
          },
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false
        },
        yAxisIndex: 0,
        data: [0, 151, 302, 453, 604, 755],
      },
    ],
    series: [
      {
        name: "健康教育",
        type: "bar",
        stack: "total",
        barWidth: 10,
        label: {
          show: false,
        },
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          normal: {
            color: "rgba(10, 115, 255, 0.8)",
          },
        },
        data: data.ydata1,
      },
      {
        name: "手机知识",
        type: "bar",
        stack: "total",
        barWidth: 10,
        label: {
          show: false,
        },
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          normal: {
            color: "rgba(61, 171, 255, 0.8)",
          },
        },
        data: data.ydata2,
      },
      {
        name: "防诈骗",
        type: "bar",
        stack: "total",
        barWidth: 10,
        label: {
          show: false,
        },
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          normal: {
            color: "rgba(121, 218, 255, 0.8)",
            barBorderRadius: [10, 10, 0, 0],
          },
        },
        data: data.ydata3,
      },
    ],
  }
}

